import { Box } from '@mui/material'

import { useBranding } from '../../hooks'

const DEFAULT_FOOTER_IMAGE = '/powered-by-givewise.png'

export function BrandedFooter() {
  const branding = useBranding()

  const primaryColor = branding?.primaryColor || '#64bee5'

  return (
    <Box component="footer" sx={{ width: '100%', mt: 'auto' }}>
      {/* Primary color bar */}
      <Box
        sx={{
          width: '100%',
          height: '8px',
          backgroundColor: primaryColor,
        }}
      />

      {/* Footer image */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          py: 1,
        }}
      >
        <Box
          component="img"
          src={DEFAULT_FOOTER_IMAGE}
          alt="Footer logo"
          sx={{
            maxHeight: '50px',
            maxWidth: '250px',
            objectFit: 'contain',
          }}
        />
      </Box>
    </Box>
  )
}

export default BrandedFooter
